import { render, staticRenderFns } from "./content-box.vue?vue&type=template&id=d518b2fe&scoped=true&"
import script from "./content-box.vue?vue&type=script&lang=ts&"
export * from "./content-box.vue?vue&type=script&lang=ts&"
import style0 from "./content-box.vue?vue&type=style&index=0&id=d518b2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518b2fe",
  null
  
)

export default component.exports